import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useToast } from "../../components/toast/ToastProvider";
import { AppDispatch } from "../../redux/store";
import { StoreState } from "../../redux/reducers";
import { Holiday } from "../../types/Holiday";
import {
  addHoliday,
  deleteHolidayById,
  editHoliday,
  fetchHolidays,
} from "../../redux/actions/holidayAction";
import Main from "../../components/custom/Main";
import PageContainer from "../../components/custom/PageContainer";
import Modal from "../../components/Modal";
import CollapseCard from "../../components/custom/CollapseCard";
import HolidayList from "../../components/HolidayList";

const UserHolidayPage: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>();
  const toast = useToast();

  const holidays = useSelector((state: StoreState) => state.holiday);
  const [selectedHoliday, setSelectedHoliday] = useState<Holiday | null>(null);
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    dispatch(fetchHolidays()).finally(() => setLoading(false));
  }, [dispatch]);

  const handleSave = async (holiday: Holiday) => {
    setLoading(true);
    try {
      if (selectedHoliday) {
        await dispatch(editHoliday(holiday.id, holiday));
        toast("Holiday updated successfully");
      } else {
        await dispatch(addHoliday(holiday));
        toast("Holiday added successfully");
      }
      await dispatch(fetchHolidays());
      setSelectedHoliday(null);
      setShowModal(false);
    } catch (error) {
      toast("Error saving holiday");
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id: number) => {
    if (window.confirm("Are you sure you want to delete this holiday?")) {
      setLoading(true);
      try {
        await dispatch(deleteHolidayById(id));
        toast("Holiday deleted successfully");
        await dispatch(fetchHolidays());
      } catch (error) {
        toast("Error deleting holiday");
      } finally {
        setLoading(false);
      }
    }
  };

  const handleEdit = (holiday: Holiday) => {
    setSelectedHoliday(holiday);
    setShowModal(true);
  };

  return (
    <Main>
      <PageContainer title="Holiday Management">
        <CollapseCard title="Holiday List">
          <HolidayList
            holidays={holidays}
            onEdit={handleEdit}
            onDelete={handleDelete}
          />
        </CollapseCard>
      </PageContainer>
    </Main>
  );
};

export default UserHolidayPage;
